<div class="business-card">
  <!-- Skeleton State -->
  <div class="card-layout" *ngIf="isLoading">
    <div class="avatar-section">
      <div class="avatar-container">
        <p-skeleton shape="circle" size="5rem" />
      </div>
    </div>
    <div class="info-section">
      <div class="header-info">
        <div class="mb-2">
          <p-skeleton
            width="12rem"
            height="1.5rem"
            styleClass="name-skeleton" />
        </div>
        <div class="mb-2">
          <p-skeleton width="8rem" height="1rem" styleClass="title-skeleton" />
        </div>
      </div>
      <div class="divider-skeleton">
        <p-skeleton width="100%" height="2px" />
      </div>
      <div class="contact-info">
        <div class="mb-2">
          <p-skeleton
            width="10rem"
            height="0.9rem"
            styleClass="contact-skeleton"
            class="mb-1" />
        </div>
        <div class="mb-2">
          <p-skeleton
            width="8rem"
            height="0.9rem"
            styleClass="contact-skeleton"
            class="mb-1" />
        </div>
        <div class="mb-1">
          <p-skeleton
            width="9rem"
            height="0.9rem"
            styleClass="contact-skeleton" />
        </div>
      </div>
    </div>
  </div>

  <!-- Content State -->
  <div class="card-layout" *ngIf="!isLoading">
    <div class="avatar-section">
      <div class="avatar-container">
        <img
          [src]="userAvatorDetails.profileImageUrl"
          alt="Profile"
          onerror="
            this.onerror = null;
            this.src = '/assets/images/avatar-default.webp';
          "
          class="profile-image" />
      </div>
    </div>
    <div class="info-section">
      <div class="header-info">
        <h2 class="user-name">{{ userAvatorDetails.name }}</h2>

        <div class="contact-item" *ngIf="userAvatorDetails.personalNumber">
          <p class="contact-text mb-0">
            Personal Number: {{ userAvatorDetails.personalNumber }}
          </p>
        </div>
      </div>
      <div class="divider"></div>
      <div class="contact-info">
        <div
          class="contact-item d-flex gap-2 align-items-end"
          *ngIf="userAvatorDetails.email">
          <span class="contact-text-icon"><i class="pi pi-envelope"></i></span>
          <span class="contact-text">{{ userAvatorDetails.email }}</span>
        </div>

        <div
          class="contact-item d-flex gap-2 align-items-end"
          *ngIf="userAvatorDetails.locationName">
          <span class="contact-text-icon"
            ><i class="pi pi-map-marker"></i
          ></span>
          <span class="contact-text">{{ userAvatorDetails.locationName }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="d-flex align-items-center justify-content-between">
    <h2>Heading1</h2>
  </div>
  <div class="scroll-padding">
    <div class="review-col">
      <div class="meta d-flex justify-content-between cstm-colm">
        <div class="row">
          <div
            class="reviewer-name d-flex align-items-center col-12 pophover-img-rounded">
            <img
              [src]="userAvatorDetails.profileImageUrl"
              alt="/assets/images/avatar-default.webp"
              onerror="this.onerror=null;this.src='/assets/images/avatar-default.webp';" />
          </div>
          <div class="reviewer-name d-flex align-items-center col-12">
            <span class="name">Name: {{ userAvatorDetails.name }}</span>
          </div>
          <div class="reviewer-name d-flex align-items-center col-12">
            <span class="name">Login Email: {{ userAvatorDetails.email }}</span>
          </div>

          <div class="reviewer-name d-flex align-items-center col-12">
            <span class="name"
              >Personal Number: {{ userAvatorDetails.personalNumber }}</span
            >
          </div>

          <div class="reviewer-name d-flex align-items-center col-12">
            <span class="name"
              >Location: {{ userAvatorDetails.locationName }}</span
            >
          </div>

          <div class="reviewer-name d-flex align-items-center col-12">
            <img
              style="width: 200px; height: 200px"
              [src]="userAvatorDetails.profileImageUrl"
              alt="/assets/images/avatar-default.webp"
              onerror="this.onerror=null;this.src='/assets/images/avatar-default.webp';" />
          </div>
        </div>
      </div>
    </div>
  </div> -->
